import React from "react";
import { activeIcon } from "../../../infecto-lms-webapp-impl/color";
import { IconWrapper } from "./icon.styles";
import { IconProps } from "./icon.interface";
import { IconMap } from "./icon.const";

export const Icon = ({
	icon,
	paletteColor,
	active,
	sizeInRem,
	style,
	circleOutlineColor,
	onClick,
	onMouseEnter,
	id,
}: IconProps) => {
	const colorToUse = active ? activeIcon.rgbValue() : paletteColor.rgbValue();

	const selectedIcon = IconMap[icon];
	const Icon = selectedIcon.icon;
	const adjustableStyles = selectedIcon.styles;

	const fillAlsoColor = adjustableStyles.includes("fill-also") ? colorToUse : undefined;

	const svgProps: React.SVGAttributes<SVGElement> = {
		...(sizeInRem && { width: `${sizeInRem}rem`, height: `${sizeInRem}rem` }),
		...(adjustableStyles.includes("stroke") && { stroke: colorToUse }),
		...(adjustableStyles.includes("fill") && { fill: colorToUse }),
		...style,
		...{ display: "block" },
	};
	return (
		<IconWrapper
			backgroundColor={circleOutlineColor}
			onClick={onClick}
			onMouseEnter={onMouseEnter}
			style={{ ...(onClick && { cursor: "pointer" }) }}
			fillAlsoColor={fillAlsoColor}
			id={id}
		>
			<Icon {...svgProps} />
		</IconWrapper>
	);
};
